import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MaterialModule } from '@app/shared/material/material.module';
import { UserService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'income-expense-dropdown',
  templateUrl: './income-expense-dropdown.component.html',
  styleUrls: ['./income-expense-dropdown.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  standalone: true,
  imports: [MatFormFieldModule, ReactiveFormsModule, FormsModule, MatSelectModule, MatIconModule, MatDividerModule, MaterialModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncomeExpenseDropdownComponent implements OnInit, OnDestroy {
  @Input() control!: any;
  @Input() premiumForm!: UntypedFormGroup;
  subscription: Subscription = new Subscription();
  incomeCategories: any[];
  expenseCategories: any[];
  selectedCategories: any[];
  selectedCategoryItem = undefined;
  filteredSubCategories = [];
  createCategoryControl = new FormControl();
  premiumCategoryValue = '';
  parentCategory = '';
  categoryValue;
  isFetchedCategories = false;
  constructor(private toastr: ToastrService, private cd: ChangeDetectorRef, private userService: UserService) {
    this.addStyleToDom();
  }

  showComponent = false;
  ngOnInit(): void {
    this.control?.value ? (this.categoryValue = this.control.value) : '';

    let transactionType = this.control?.reportingType?.toLowerCase() ?? 'expense';
    this.transactionType = transactionType;
    this.getAllCategoriesBasedOnType(transactionType);
    this.subscription.add(this.premiumForm.valueChanges.subscribe((change) => {}));
  }
  previousValue: any;
  isMatMenuOpened = false;
  onOpenedChange(event) {
    this.previousValue = this.premiumForm.controls[this.control?.key].value;
    this.isMatMenuOpened = event;
  }
  logKey(event) {
    event.preventDefault();
    event.stopPropagation();
    this.select.close();
  }

  @ViewChild('select') select: MatSelect;

  onPaymentFreqSelection(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
  onSelectClosed(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.selectedCategoryItem = undefined;
  }
  handleSubcategory(event, item) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.premiumForm.controls['category'].setValue(item.name);
    this.selectedCategoryItem = undefined;
  }
  selectCategory(e: Event, item: any) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (!!this.selectedCategoryItem) {
      this.selectedCategoryItem = undefined;
      this.filteredSubCategories = undefined;
      this.createCategoryControl.setValue('');
      this.parentCategory = '';
    } else {
      this.selectedCategoryItem = item;
      this.filteredSubCategories = this.selectedCategoryItem?.subCategories;
      this.createCategoryControl.setValue('');
      this.parentCategory = this.selectedCategoryItem?.name;
    }

    this.cd.detectChanges();
  }
  getValue(event, type) {
    const strFix = `${event}`.replace(/,/g, '');
    if (type == 'payment_amount') this.premiumForm.controls['payment_amount'].patchValue(strFix);
    if (type == 'surrender-value') this.premiumForm.controls['payment_frequency'].patchValue(strFix);
  }

  selectAllContent(event) {
    event.target.select();
  }

  ngOnDestroy() {
    this.parentCategory = '';
    this.subscription.unsubscribe();
  }
  handleSearch(e: any) {
    const event = e.trim();
    if (!this.selectedCategoryItem) {
      if (event.length > 0) {
        this.expenseCategories = this.allExpenseCategories.filter((item) => item.name.toLowerCase().includes(event.toLowerCase()));
      } else {
        this.expenseCategories = this.allExpenseCategories;
      }
    } else {
      if (event.length > 0) {
        this.filteredSubCategories = this.selectedCategoryItem?.subCategories.filter((item) => item.name.toLowerCase().includes(event.toLowerCase()));
      } else {
        this.filteredSubCategories = this.selectedCategoryItem?.subCategories;
      }
    }
  }
  allExpenseCategories = [];
  async getAllCategoriesBasedOnType(transactionType) {
    this.subscription.add(
      this.userService.getAllCategoriesBasedOnType(transactionType).subscribe(
        (res) => {
          this.expenseCategories = res;
          this.allExpenseCategories = res;
          if (!!this.selectedCategoryItem) {
            const exist = this.allExpenseCategories.find(
              (item) => item?.name?.trim().toLowerCase() == this.selectedCategoryItem.name.trim().toLowerCase()
            );
            this.selectedCategoryItem = exist;
            this.filteredSubCategories = this.selectedCategoryItem.subCategories;
            this.cd.detectChanges();
          }
          if (this.control?.value) {
            // this.premiumForm.controls['category'].setValue('');
            // this.premiumCategoryValue = '';
            // this.premiumForm.controls['category'].setValue(this.control?.value);
            // this.premiumCategoryValue = this.control?.value;
          }

          // setTimeout(() => {
          this.isFetchedCategories = true;
          this.cd.detectChanges();
          // }, 500);
        },
        (error: any) => {
          this.toastr.error('Error occurred while getting income categories');
        }
      )
    );
  }
  isAddingNewExpenseCategory = false;
  expenseCategoryName = '';
  addNewExpenseCategory(event: Event) {
    event.stopPropagation();
    this.isAddingNewExpenseCategory = !this.isAddingNewExpenseCategory;
  }
  transactionType = 'expense'; // 'income' or 'expense
  createIncomeExpenseCategoryOrSubcategory(type) {
    if (this.createCategoryControl.value.trim() == '') {
      this.createCategoryControl.setErrors({ foundError: true });
      return;
    }
    if (type == 'category') {
      const exist = this.allExpenseCategories.find((item) => item.name.trim().toLowerCase() == this.createCategoryControl.value.trim().toLowerCase());
      if (exist) {
        this.createCategoryControl.setErrors({ foundError: true });
        return;
      }
    } else {
      const exist = this.selectedCategoryItem.subCategories.find(
        (item) => item.name.trim().toLowerCase() == this.createCategoryControl.value.trim().toLowerCase()
      );
      if (exist) {
        this.createCategoryControl.setErrors({ foundError: true });
        return;
      }
    }
    const payload = {
      name: this.createCategoryControl.value,
      type: this.transactionType,
    };

    if (type == 'sub-category') {
      payload['income_expense_category_user_id'] = this.selectedCategoryItem.source == 'user' ? this.selectedCategoryItem.id : null;
      payload['income_expense_category_system_id'] = this.selectedCategoryItem.source == 'system' ? this.selectedCategoryItem.id : null;
    }

    this.subscription.add(
      this.userService.createIncomeExpenseCategory(type, payload).subscribe(
        (res) => {
          // console.log({ res, payload });
          this.isAddingNewExpenseCategory = false;
          this.getAllCategoriesBasedOnType(this.transactionType);
          this.createCategoryControl.setValue('');
        },
        (error: any) => {
          this.toastr.error('Error occurred while getting expense categories');
        }
      )
    );
    this.cd.detectChanges();
  }
  selectSubcategory() {
    this.selectedCategories.forEach((element) => {
      element.isOpen = false;
    });
  }
  closeFormSection() {
    this.isAddingNewExpenseCategory = false;
    this.createCategoryControl.setValue('');
  }
  handleLogChange(event) {
    this.premiumForm?.controls[this.control?.key].setValue(event);
    this.cd.detectChanges();
  }

  addStyleToDom() {
    const linkElement = document.createElement('link');
    linkElement.rel = 'stylesheet';
    linkElement.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0';
    document.head.appendChild(linkElement);
  }
}
